var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',[_c('vc-toolbar',{attrs:{"title":"Importación de cotización"}}),_c('v-container',[_c('v-row',[_c('v-col',[_c('vc-import-excel',{attrs:{"verify":true},on:{"verifyRules":function($event){return _vm.verifyRules($event)},"clear":function($event){return _vm.clear()}}})],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }